"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePaddle = void 0;

var _react = require("react");

var _axios = _interopRequireDefault(require("axios"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var usePaddle = function usePaddle() {
  var Paddle = window.Paddle;
  var openPayment = (0, _react.useCallback)(function (_ref) {
    var passthrough = _ref.passthrough,
        product = _ref.product,
        email = _ref.email,
        rest = _objectWithoutProperties(_ref, ["passthrough", "product", "email"]);

    Paddle.Checkout.open(_objectSpread({
      email: email,
      method: 'inline',
      product: product,
      allowQuantity: false,
      passthrough: passthrough,
      disableLogout: true,
      frameTarget: 'checkout-container',
      // The className of yomour checkout <div>
      frameInitialHeight: 416,
      frameStyle: 'width:100%; min-width:290px; background-color: transparent; border: none;'
    }, rest));
  }, [Paddle]);

  var getPaymentLink = function getPaymentLink(_ref2) {
    var teamId = _ref2.teamId;
    return _axios["default"].get("/team/checkout-link/".concat(teamId)).then(function (_ref3) {
      var responseData = _ref3.data;
      return responseData.link;
    });
  };

  return {
    openPayment: openPayment,
    getPaymentLink: getPaymentLink
  };
};

exports.usePaddle = usePaddle;